import AddressFormatter from "@shopify/address";
import { useQuery } from "@tanstack/react-query";

export const useAddressOrderedFieldsQuery = ({
  countryCode,
  locale,
}: {
  countryCode: string;
  locale: string;
}) => {
  const data = useQuery({
    queryKey: ["addressOrderedFields", countryCode, locale],
    queryFn: async () => {
      const addressFormatter = new AddressFormatter(locale);
      return await addressFormatter.getOrderedFields(countryCode);
    },
  });

  return data;
};
